<template>
  <div>
    <v-card rounded outlined>
        <div style="width: 100%" @click="showDetails = !showDetails" :class="{'d-flex align-center param-title':true, 'param-title-selected':showDetails}">
            <!-- title -->
            <div>
                <v-card-title class="pb-0 back_accent-x">
                    {{ $t('result.motivators.title') }}
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text class="pt-0 back_accent-x">
                    {{$t('result.motivators.text')}}
                </v-card-text>
            </div>
            <v-spacer/>
            <a class="subtitle-2 ml-2 mr-5" style="text-decoration: none" href="javascript:void(0)">
                <span v-if="showDetails">{{$t('result.toggle_summary')}}</span>
                <span v-else>{{$t('result.toggle_detail')}}</span>
            </a>
        </div>
        <div
                v-for="(mg, index, mkey) in motivatorGroups"
                :key="mkey"
        >
            <v-card-text
                    v-if="Object.keys(result.scores[mg]).length > 0"
                    class="py-5">
                <h3 class="my-5">{{getGroupTitle(mg)}}</h3>
                <div
                        v-for="(term,index,key) in result.scores[mg]"
                        :key="key"
                >
                    <div v-if="showDetails" class="my-2">
                        <distribution
                            :title="getTermByLocale(term, mg)"
                            :value="term.value"
                            :distro="getDistro(term.key)"
                            :tkey="term.key"
                            type="motivator"
                        />
                    </div>
                    <div v-else class="my-4">
                        <score-bar
                                :id="'motivator-'+key"
                                :title="getTermByLocale(term, mg)"
                                :value="term.value"
                                :options="{type:'summary',scale: 2}"
                        >
                        </score-bar>
                    </div>
                </div>
            </v-card-text>
        </div>
    </v-card>
  </div>
</template>

<script>
  import ResultUtils from "../resultUtils";
  import ScoreBar from "@/components/ScoreBar.vue";
  import Distribution from "@/components/team/distribution.vue";
  export default {
    name: "teamMotivators",
    props: ['result'],
    components: {
        Distribution,
      ScoreBar,
      ItemBalance: () => import('../../components/ItemBalance'),
      BallsSummary: () => import('../../components/BallsSummary'),
    },
    data() {
      return {
          showDetails: false,
          groups: {
              work: 1,
              health: 2,
              family: 3,
              custom: 4,
          }
      }
    },
    computed: {
      colors() {
        return this.$store.getters['app/colors']
      },
      showAll(){
        return this.$store.getters['diagnostic/showAll']
      },
        share() {
            return this.$router.currentRoute.name === 'shareTeam'
        },
        shareTopics() {
            return (!this.share || (this.$store.getters['team/isShared'] && this.$store.getters['team/shareOptions'].topics));
        },
        motivatorGroups() {
          return this.shareTopics ? ['work','health','family','custom'] : ['work','custom'];
        }
    },
    methods: {
      getTermByLocale(term, type) {
          if (type === 'custom') {
              return this.result.groups.custom[term.key].title;
          }
          return ResultUtils.getTermByKeyLocale(term.key, this.result.locale, this.$i18n.locale)

      },
        getGroupTitle(group) {
          if (group === 'work') {
              return this.$t(`result.motivators.groups.${this.groups[group]}.${this.result.type}`)
          } else {
              return this.$t(`result.motivators.groups.${this.groups[group]}`)
          }
        },
        getDistro(key) {
          const distro = [
              this.result.distro[1][key],
              this.result.distro[2][key],
              this.result.distro[3][key],
              this.result.distro[4][key],
              this.result.distro[5][key],
          ];
          return distro;
        }
    },
    created() {
        this.showDetails = this.showAll
    },
    watch: {
        showAll: function(val) {
            this.showDetails = val
        }
    }
  }
</script>
